import { render, staticRenderFns } from "./SpeechAndLanguageWrapper.vue?vue&type=template&id=1726367e&scoped=true"
import script from "./SpeechAndLanguageWrapper.vue?vue&type=script&lang=js"
export * from "./SpeechAndLanguageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726367e",
  null
  
)

export default component.exports